import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import React from "react";
import { TextFieldBOValidate } from "../../../TextFieldBO/TextFieldBOValidate";

export const MedicalData = ({ register, errors, watch }) => {
  const { grupoSangre, alergias, enfermedades, medicacion } = watch() || {};
  return (
    <Box>
      <Accordion>
        <AccordionSummary
          expandIcon={<CaretDown size={32} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={700} color={"primary"}>
            Datos Médicos
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextFieldBOValidate
            register={register}
            name="grupoSangre"
            label={"Grupo Sanguineo"}
            errors={errors}
            maxLength={30}
            length={grupoSangre?.length}
          />
          <TextFieldBOValidate
            register={register}
            name="alergias"
            label={"Alergias"}
            errors={errors}
            maxLength={100}
            length={alergias?.length}
          />
          <TextFieldBOValidate
            register={register}
            name="enfermedades"
            label={"Diagnósticos"}
            errors={errors}
            maxLength={100}
            length={enfermedades?.length}
          />
          <TextFieldBOValidate
            register={register}
            name="medicacion"
            label={"Medicación"}
            errors={errors}
            maxLength={100}
            length={medicacion?.length}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
